export const toYmd = (date: Date) => {
	const y = date.getFullYear()
	const m = String(date.getMonth() + 1).padStart(2, '0')
	const d = String(date.getDate()).padStart(2, '0')
	return `${y}-${m}-${d}`
}

export const todayYmd = () => toYmd(new Date())

export const shiftYmd = (ymd: string, days: number) => {
	const [y, m, d] = ymd.split('-').map(Number)
	const date = new Date(y, (m || 1) - 1, d || 1)
	date.setDate(date.getDate() + days)
	return toYmd(date)
}

export const resolveInventoryBackdateDays = (source?: any) => {
	const raw = source?.inventoryBackdateDays ?? source?.inventory_backdate_days
	const parsed = Number(raw)
	return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 0
}

export const resolveAccountingBackdateDays = (source?: any) => {
	const raw = source?.accountingBackdateDays ?? source?.accounting_backdate_days
	const parsed = Number(raw)
	return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 0
}

export const getInventoryDateBounds = (backdateDays?: number | null) => {
	const maxDate = todayYmd()
	const allowed = Number(backdateDays)
	const limited = Number.isFinite(allowed) && allowed > 0 ? Math.floor(allowed) : 0
	return {
		minDate: limited > 0 ? shiftYmd(maxDate, -limited) : '',
		maxDate,
		backdateDays: limited,
	}
}

export const clampToInventoryDateBounds = (date: string, backdateDays?: number | null) => {
	const { minDate, maxDate } = getInventoryDateBounds(backdateDays)
	if (!date || date > maxDate) return maxDate
	if (minDate && date < minDate) return minDate
	return date
}

export const inventoryDateHint = (hasProject: boolean, backdateDays?: number | null) => {
	if (!hasProject) {
		return 'Select a project first to set the allowed date range.'
	}

	const { backdateDays: days } = getInventoryDateBounds(backdateDays)
	return days > 0
		? `You can backdate up to ${days} day(s). Future dates are not allowed.`
		: 'Previous dates are allowed. Future dates are not allowed.'
}

export const inventoryDateError = (date: string, backdateDays?: number | null) => {
	if (!date) {
		return 'Please select Date.'
	}

	const { minDate, maxDate, backdateDays: days } = getInventoryDateBounds(backdateDays)
	if (date > maxDate) {
		return 'Date cannot be after today.'
	}
	if (minDate && date < minDate) {
		return `Date cannot be more than ${days} day(s) before today.`
	}

	return null
}
